export enum METADATA_ATTR {
  'MASTERCLASS',
  'SERIE',
  'PERCORSO',
  'INSEGNANTE',
}

export const METADATA_MUX_ATTRS: Record<METADATA_ATTR, string> = {
  [METADATA_ATTR.MASTERCLASS]: 'custom_2',
  [METADATA_ATTR.PERCORSO]: 'custom_1',
  [METADATA_ATTR.SERIE]: 'video_series',
  [METADATA_ATTR.INSEGNANTE]: 'sub_property_id',
};
